import type { IGetAgentModelResponse } from 'features/chat/agent-chat-module/services/gpt-chat.service';
import { getProviderDisplayName } from 'pages/models/models.utils';

type ResolveLlmDisplayLabelParams = {
  currentLlmModel: string;
  currentLlmProvider: string;
  currentLlmModelId?: string;
  isBlocksProvider: boolean;
  availableChatModels: IGetAgentModelResponse;
  availableCustomChatModels: IGetAgentModelResponse;
  fallbackLabel?: string;
};

export function resolveLlmDisplayLabel({
  currentLlmModel,
  currentLlmProvider,
  currentLlmModelId = '',
  isBlocksProvider,
  availableChatModels,
  availableCustomChatModels,
  fallbackLabel,
}: ResolveLlmDisplayLabelParams): { label: string; region?: string } {
  if (!currentLlmProvider || !currentLlmModel) {
    return { label: fallbackLabel || currentLlmModel || '' };
  }

  if (isBlocksProvider) {
    for (const model of availableChatModels) {
      if (model.provider === currentLlmProvider && model.model_name === currentLlmModel) {
        return {
          label: `Blocks / ${model.provider_label} / ${model.model_name_label}`,
          region: model.region,
        };
      }
    }

    return { label: fallbackLabel || currentLlmModel };
  }

  const foundModel = availableCustomChatModels.find((model) => model.id === currentLlmModelId);
  const providerLabel = foundModel?.provider_label || getProviderDisplayName(currentLlmProvider);

  return {
    label: `My Model / ${providerLabel} / ${foundModel?.model_name_label || currentLlmModel}`,
    region: foundModel?.region,
  };
}
